export enum DriveEditableStatus {
  Blue = 'blue',
  Green = 'green',
  Grey = 'grey',
}

export enum ProtectionType {
  Armoured = 'armoured',
  Soft = 'soft',
}

export interface CalendarResourceLabelContentProps {
  resource: {
    extendedProps: Partial<IPlannerResources>;
    id: string;
    title: string;
  };
}

export interface IPlannerDrivesApi {
  driver_agency: string;
  driver_email: string;
  driver_first_name: string;
  driver_id: string;
  driver_last_name: string;
  driver_phone_number: string;
  dropoff_date: string;
  dropoff_location: string;
  dropoff_time: string;
  dropoff_town: string;
  editable_state: DriveEditableStatus;
  is_conflicting: boolean;
  passenger_agency: string;
  passenger_email: string;
  passenger_first_name: string;
  passenger_last_name: string;
  passenger_number_of_pax: string;
  passenger_phone_number: string;
  passenger_remarks: string | null;
  pickup_date: string;
  pickup_location: string;
  pickup_time: string;
  pickup_town: string;
  uuid: string;
  vehicle_agency: string;
  vehicle_id: string;
}

export interface IPlannerDrives {
  driverAgency: string;
  driverEmail: string;
  driverFirstName: string;
  driverId: string;
  driverLastName: string;
  driverPhone: string;
  dropoffDate: string;
  dropoffLocation: string;
  dropoffTime: string;
  dropoffTown: string;
  editableState: DriveEditableStatus;
  id: string;
  isConflicting: boolean;
  passengerAgency: string;
  passengerEmail: string;
  passengerFirstName: string;
  passengerLastName: string;
  passengerPax: string;
  passengerPhone: string;
  passengerRemarks: string;
  pickupDate: string;
  pickupLocation: string;
  pickupTime: string;
  pickupTown: string;
  vehicleAgency: string;
  vehicleId: string;
}

export interface IPlannerEvent {
  className: string;
  end: Date;
  id: string;
  resourceId: string;
  start: Date;
  title: string;
  extendedProps: IPlannerDrives;
}

export interface IPlannerResources {
  agencyLogo: string | null;
  id: string;
  image: string;
  isDisabled?: boolean;
  maxCapacity: number;
  plateNumber: string;
  preferredDriver: string | null;
  protection: string;
  shared: boolean;
  sharedAgency: Array<string>;
  title: string;
  vehicleAgency: string | null;
}

export interface IPlannerVehiclesApi {
  agency_logo: string | null;
  image: string;
  is_disabled: boolean;
  label: string;
  max_capacity: number;
  plate_number: string;
  preferred_driver: string | null;
  protection: ProtectionType;
  shared: boolean;
  shared_agency: Array<string>;
  vehicle_agency: string | null;
  vehicle_identifier: string;
}
